import { Box, useTheme } from "@mui/material";
import React, { useRef, useEffect, useState } from "react";

interface Props {
    children: React.ReactNode;
    maxHeight: number;
    scrollToBottom?: boolean;
}

function OverflowWrapper({ maxHeight, scrollToBottom, children }: Props) {
    const theme = useTheme();
    const contentRef = useRef<HTMLDivElement>(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
        const contentElement = contentRef.current;
        if (contentElement) {
            setIsOverflowing(contentElement.scrollHeight > 550);
        }
    }, [children]);

    const contentStyle = isOverflowing
        ? {
            maxHeight: `${maxHeight}px`,
            overflow: "auto",
            display: "flex",
            flexDirection: scrollToBottom ? "column-reverse" : "column",
            border: "2px solid transparent",
            // Custom scrollbar for Webkit browsers
            '::-webkit-scrollbar': {
                width: '6px',
                height: '6px',
            },
            '::-webkit-scrollbar-thumb': {
                background: theme.palette.divider,
                borderRadius: '3px',
            },
            'scrollbarWidth': 'thin', // Firefox
            'scrollbarColor': `${theme.palette.divider} transparent`,
        }
        : {};

    return (
        <Box ref={contentRef} sx={contentStyle}>
            {children}
        </Box>
    );
}

export default OverflowWrapper;
